import { createApiSlice } from "@common";
import { CRUD_IDEAL_CUSTOMER_PROFILE } from "@routes";

const apiConfig = [
  {
    name: "addIdealCustomerProfile",
    method: "post",
    url: CRUD_IDEAL_CUSTOMER_PROFILE,
    stateKey: "message",
  },
  {
    name: "getIdealCustomerProfile",
    method: "get",
    url: CRUD_IDEAL_CUSTOMER_PROFILE,
    stateKey: "data",
  },
  {
    name: "updateIdealCustomerProfile",
    method: "put",
    url: CRUD_IDEAL_CUSTOMER_PROFILE,
    stateKey: "message",
  },
  {
    name: "deleteIdealCustomerProfile",
    method: "delete",
    url: CRUD_IDEAL_CUSTOMER_PROFILE,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "idealCustomerProfile",
  apiConfig,
  customReducers);
const idealCustomerProfileSlice = slice;

export default idealCustomerProfileSlice.reducer;

export const {
  addIdealCustomerProfile,
  getIdealCustomerProfile,
  updateIdealCustomerProfile,
  deleteIdealCustomerProfile,
} = thunks;

export const { rowSelect } = actions;
